import {
  Block,
  FlexGrid,
  FlexGridItem,
  Trophy02,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { selectUserLeaderboardRank, useDappSelector } from "#/redux-state"
import { useLeaderboardRank } from "#/shared/hooks"

import { StatsCard, StatsHodlScoreCard, StatsMatsRankCard } from "../Stats"

export default function MatsStats() {
  const { rank } = useDappSelector(selectUserLeaderboardRank)

  const [, theme] = useStyletron()
  const { rankData } = useLeaderboardRank()

  return (
    <FlexGrid
      flexGridColumnCount={[1, 1, 1, 3]}
      flexGridColumnGap="scale300"
      flexGridRowGap="scale300"
      marginBottom="scale1600"
    >
      <FlexGridItem
        overrides={{
          Block: {
            style: () => ({
              flexGrow: 0,
              width: "100%",
              maxWidth: ["100%", "100%", "100%", "372px"],
            }),
          },
        }}
      >
        <StatsHodlScoreCard />
      </FlexGridItem>
      {rank && (
        <FlexGridItem
          overrides={{
            Block: {
              style: () => ({
                flexGrow: 0,
                width: "100%",
                maxWidth: ["100%", "100%", "100%", "372px"],
              }),
            },
          }}
        >
          <StatsMatsRankCard />
        </FlexGridItem>
      )}
      {rankData && (
        <FlexGridItem>
          <StatsCard
            value={
              <Block as="span" color={theme.colors.yellow600}>
                {rankData.text}
              </Block>
            }
            title={<Trophy02 size={20} color={theme.colors.yellow600} />}
            backgroundColor={theme.colors.yellow300}
          />
        </FlexGridItem>
      )}
    </FlexGrid>
  )
}
